import type from "./type";

export default type("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
});



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-request/src/html.js
// module id = ../../../../d3-request/src/html.js
// module chunks = 3